import { render, staticRenderFns } from "./RD.vue?vue&type=template&id=048da379&scoped=true"
import script from "./RD.vue?vue&type=script&lang=js"
export * from "./RD.vue?vue&type=script&lang=js"
import style0 from "./RD.vue?vue&type=style&index=0&id=048da379&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048da379",
  null
  
)

export default component.exports